module.exports = __webpack_public_path__ + "static/dms-screen-desktop.b419d074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/cases/dms/img/dms-screen-desktop.jpg
// module id = 723
// module chunks = 267937933260274